import gql from 'graphql-tag';

const externalAuctionLocationsQuery = gql`
  query externalAuctionLocationsQuery {
    externalAuctionLocations {
      id
      initials
      name
      auctionedge_code
      partnerNetwork
      acceptsReturns
    }
  }
`;

export default externalAuctionLocationsQuery;
